<div class="row" *ngIf="!loader">
    <div class="col-12">
        <mat-card appearance="outlined">
            <sm-title-bar pageSubTitle="All abuse reports" [showBackButton]="true"></sm-title-bar>
            <div class="rounded-3 bg-light">
              <sm-data-table [columnHeaders]="tableDisplayColumns" [dataSource]="reportList"
                [showMenuButton]="true" [menuDropdownTemplate]="menuTemplate" [showFilter]="true" [showPagination]="true" [itemsPerPage]="5">
              </sm-data-table>
            </div>
          </mat-card>
    </div>
</div>
<div *ngIf="loader" class="loader">
  <mat-spinner></mat-spinner>
</div>
<ng-template #menuTemplate let-value>
  <button mat-menu-item (click)="viewDetails(value)">
    <mat-icon class="material-icons-outlined">info</mat-icon>
    <span>View details</span>
  </button>
  <button mat-menu-item>
    <mat-icon class="material-icons-outlined">email</mat-icon>
    <span>Send message</span>
  </button>
  <button mat-menu-item (click)="blockReported(value)" *ngIf="value.adminStatus === 0 || value.adminStatus === 1">
    <mat-icon class="material-icons-outlined">app_blocking</mat-icon>
    <span>Block content</span>
  </button>
  <button mat-menu-item (click)="unblockReported(value)" *ngIf="value.adminStatus === 9">
    <mat-icon class="material-icons-outlined">lock_open</mat-icon>
    <span>Unblock content</span>
  </button>
</ng-template>